import Swal from "sweetalert2";
import axios from "axios";

export const handleVNPayPayment = async (
  bookingSidebar,
  totalamount,
  totaldays,
  guestDetails,
  setLoading
) => {
  if (Object.values(guestDetails).some((field) => !field)) {
    Swal.fire("Error", "All guest information fields are required.", "error");
    return;
  }

  console.log("Sending VNPay Payment Request:", {
    totalamount,
    totaldays,
    bookingSidebar,
    guestDetails,
  });

  setLoading(true);
  try {
    // Call backend to get VNPay URL
    const response = await axios.post("/api/payment/vnpay/create", {
      totalamount,
      totaldays,
      bookingSidebar,
      guestDetails,
    });
    console.log("VNPay Payment URL Response:", response.data);

    if (response.data.paymentUrl) {
      // Redirect to VNPay payment page
      window.location.href = response.data.paymentUrl;
    } else {
      Swal.fire(
        "Error",
        "Failed to initiate VNPay payment. Please try again.",
        "error"
      );
    }
  } catch (error) {
    console.error("Error initiating VNPay payment:", error);
    Swal.fire(
      "Error",
      "Failed to initiate VNPay payment. Please try again.",
      "error"
    );
  } finally {
    setLoading(false);
  }
};
